import { Injectable, inject, signal } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LibSignatureViewModalComponent } from '@libs/client';
import { SignatureViewOpener } from '@libs/util-services';

/**
 * Implementação concreta do SIGNATURE_VIEW_OPENER para o lessor.
 *
 * <p>Abre o detalhe da assinatura (termo inteiro + traço) num modal
 * fullscreen. Chamado pelo badge "Termo" do card do jogador, que mora na
 * util-ui e não pode importar a client-lib.
 *
 * <p>`signatureId` vai como `signal(id)`: o modal declara `input<number>()` e o
 * Ionic aplica `componentProps` por `Object.assign`, sobrescrevendo o signal;
 * entregar um signal no lugar mantém o `this.signatureId()` do modal vivo.
 */
@Injectable({ providedIn: 'root' })
export class LessorSignatureViewOpener implements SignatureViewOpener {
  private readonly modalCtrl = inject(ModalController);

  async open(signatureId: number): Promise<void> {
    if (!signatureId) return;

    const modal = await this.modalCtrl.create({
      component: LibSignatureViewModalComponent,
      componentProps: { signatureId: signal(signatureId) },
      cssClass: 'modal-fullscreen',
    });
    await modal.present();
  }
}
